var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 3,
    r: 1
  }, /*#__PURE__*/React.createElement("animate", {
    id: "spinner_7Z73",
    begin: "0;spinner_tKsu.end-0.5s",
    attributeName: "r",
    calcMode: "spline",
    dur: "0.6s",
    values: "1;2;1",
    keySplines: ".27,.42,.37,.99;.53,0,.61,.73"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 4.21,
    r: 1
  }, /*#__PURE__*/React.createElement("animate", {
    id: "spinner_Wd87",
    begin: "spinner_7Z73.begin+0.1s",
    attributeName: "r",
    calcMode: "spline",
    dur: "0.6s",
    values: "1;2;1",
    keySplines: ".27,.42,.37,.99;.53,0,.61,.73"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 4.21,
    r: 1
  }, /*#__PURE__*/React.createElement("animate", {
    id: "spinner_tKsu",
    begin: "spinner_9Qlc.begin+0.1s",
    attributeName: "r",
    calcMode: "spline",
    dur: "0.6s",
    values: "1;2;1",
    keySplines: ".27,.42,.37,.99;.53,0,.61,.73"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 19.79,
    cy: 7.5,
    r: 1
  }, /*#__PURE__*/React.createElement("animate", {
    id: "spinner_lMMO",
    begin: "spinner_Wd87.begin+0.1s",
    attributeName: "r",
    calcMode: "spline",
    dur: "0.6s",
    values: "1;2;1",
    keySplines: ".27,.42,.37,.99;.53,0,.61,.73"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 4.21,
    cy: 7.5,
    r: 1
  }, /*#__PURE__*/React.createElement("animate", {
    id: "spinner_9Qlc",
    begin: "spinner_Khxv.begin+0.1s",
    attributeName: "r",
    calcMode: "spline",
    dur: "0.6s",
    values: "1;2;1",
    keySplines: ".27,.42,.37,.99;.53,0,.61,.73"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 12,
    r: 1
  }, /*#__PURE__*/React.createElement("animate", {
    id: "spinner_5L9t",
    begin: "spinner_lMMO.begin+0.1s",
    attributeName: "r",
    calcMode: "spline",
    dur: "0.6s",
    values: "1;2;1",
    keySplines: ".27,.42,.37,.99;.53,0,.61,.73"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 12,
    r: 1
  }, /*#__PURE__*/React.createElement("animate", {
    id: "spinner_Khxv",
    begin: "spinner_ld6P.begin+0.1s",
    attributeName: "r",
    calcMode: "spline",
    dur: "0.6s",
    values: "1;2;1",
    keySplines: ".27,.42,.37,.99;.53,0,.61,.73"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 19.79,
    cy: 16.5,
    r: 1
  }, /*#__PURE__*/React.createElement("animate", {
    id: "spinner_BfTD",
    begin: "spinner_5L9t.begin+0.1s",
    attributeName: "r",
    calcMode: "spline",
    dur: "0.6s",
    values: "1;2;1",
    keySplines: ".27,.42,.37,.99;.53,0,.61,.73"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 4.21,
    cy: 16.5,
    r: 1
  }, /*#__PURE__*/React.createElement("animate", {
    id: "spinner_ld6P",
    begin: "spinner_XyBs.begin+0.1s",
    attributeName: "r",
    calcMode: "spline",
    dur: "0.6s",
    values: "1;2;1",
    keySplines: ".27,.42,.37,.99;.53,0,.61,.73"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 19.79,
    r: 1
  }, /*#__PURE__*/React.createElement("animate", {
    id: "spinner_7gAK",
    begin: "spinner_BfTD.begin+0.1s",
    attributeName: "r",
    calcMode: "spline",
    dur: "0.6s",
    values: "1;2;1",
    keySplines: ".27,.42,.37,.99;.53,0,.61,.73"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 19.79,
    r: 1
  }, /*#__PURE__*/React.createElement("animate", {
    id: "spinner_XyBs",
    begin: "spinner_HiSl.begin+0.1s",
    attributeName: "r",
    calcMode: "spline",
    dur: "0.6s",
    values: "1;2;1",
    keySplines: ".27,.42,.37,.99;.53,0,.61,.73"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 21,
    r: 1
  }, /*#__PURE__*/React.createElement("animate", {
    id: "spinner_HiSl",
    begin: "spinner_7gAK.begin+0.1s",
    attributeName: "r",
    calcMode: "spline",
    dur: "0.6s",
    values: "1;2;1",
    keySplines: ".27,.42,.37,.99;.53,0,.61,.73"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    dur: "6s",
    values: "360 12 12;0 12 12",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.c7cdccdd5777f8bfeb7dc8c9145c29e1.svg";
export { ForwardRef as ReactComponent };